import React from 'react';
import { Modal, Button } from 'react-bootstrap';

export const ReportsSuccess = ({ show, handleClose }) => {
  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Enviado</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Los reportes han sido enviados exitosamente!</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="success" onClick={handleClose}>
          Volver
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
